import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { qtyLine } from '../lib/format';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

interface InventoryRow { day: string; slot: string; data?: Record<string, number>; counted?: Record<string, number>; }

export function Inventories() {
  const { canAny } = useAuth();
  const toast = useToast();
  const [pm, setPm] = useState('');
  const [gm, setGm] = useState('');
  const [slot, setSlot] = useState('matin');
  const [ref, setRef] = useState('');
  const [msg, setMsg] = useState<{ text: string; err: boolean } | null>(null);
  const [list, setList] = useState<InventoryRow[] | null>(null);

  async function load() {
    try { setList(await api<InventoryRow[]>('/v1/inventories')); }
    catch { setList([]); }
  }
  useEffect(() => { load(); }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const counted: Record<string, number> = {};
    if (+pm > 0) counted.PM = +pm;
    if (+gm > 0) counted.GM = +gm;
    if (!Object.keys(counted).length) { setMsg({ text: 'Indiquez au moins une quantité.', err: true }); return; }
    try {
      const res = await api<{ replayed?: boolean }>('/v1/inventories', { method: 'POST', body: { counted, slot, ref: ref.trim() || undefined } });
      setMsg({ text: res.replayed ? 'Déjà enregistré (référence rejouée).' : 'Inventaire enregistré.', err: false });
      toast('Inventaire enregistré');
      load();
    } catch (e) { setMsg({ text: e instanceof ApiError ? e.message : 'Erreur', err: true }); }
  }

  return (
    <>
      <div className="pagehead"><h1>Inventaire</h1></div>
      {canAny(['write']) && (
        <div className="card">
          <h2>Nouvel inventaire (stock central)</h2>
          <form onSubmit={submit}>
            <div className="row2">
              <div><label>Compté — PM</label><input type="number" min={0} value={pm} onChange={(e) => setPm(e.target.value)} /></div>
              <div><label>Compté — GM</label><input type="number" min={0} value={gm} onChange={(e) => setGm(e.target.value)} /></div>
            </div>
            <label>Créneau</label>
            <select value={slot} onChange={(e) => setSlot(e.target.value)}>
              <option value="matin">Matin</option><option value="soir">Soir</option>
            </select>
            <label>Référence (optionnel)</label>
            <input value={ref} onChange={(e) => setRef(e.target.value)} />
            <div className="row" style={{ marginTop: '0.8rem' }}><button type="submit" className="primary">Enregistrer l'inventaire</button></div>
            {msg && <div className={msg.err ? 'err' : 'ok'}>{msg.text}</div>}
          </form>
        </div>
      )}
      <div className="card">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h2 style={{ margin: 0 }}>Historique</h2>
          <button className="small" onClick={load}>Actualiser</button>
        </div>
        {!list && <div className="muted">Chargement...</div>}
        {list && list.length === 0 && <span className="muted">Aucun inventaire enregistré.</span>}
        {list && list.length > 0 && (
          <div className="tblwrap"><table><tbody>
            <tr><th>Jour</th><th>Créneau</th><th>Compté</th></tr>
            {list.slice().reverse().map((i, idx) => (
              <tr key={idx}><td>{i.day}</td><td>{i.slot}</td><td>{qtyLine(i.data || i.counted)}</td></tr>
            ))}
          </tbody></table></div>
        )}
      </div>
    </>
  );
}
